/* @flow strict */

import * as React from 'react';
import Modal from '/client/src/components/Modal';
import DataTable from 'react-data-table-component';
import SimpleCheckbox from '/client/src/components/forms/checkbox';
import { receiptsColumns, ticketColumns } from './tableHeaders/modal';

type PropsType = {
  isOpen: boolean,
  data: [],
  handleCloseModal: () => void,
  handleSendTickets: () => void,
  handleSendReceipts: () => void,
  tableTab: string,
  modalPending: boolean
};

export const ResendModal = ({
  isOpen,
  data,
  handleCloseModal,
  handleSendTickets,
  handleSendReceipts,
  tableTab,
  modalPending
}: PropsType): React.Element<'div'> => {
  const modalColumns = tableTab === 'tickets' ? ticketColumns() : (tableTab ===  'receipts' ? receiptsColumns() : []);
  const [needUpdateCode, setNeedUpdateCode] = React.useState(false);
  const spinnerStyles = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)'
  };

  return (
    <Modal
      altView
      isScrollable
      opened={isOpen}
      onClose={handleCloseModal}
    >
      <div className="modal-dialog modal-lg customModal" role="document">
        <div className="modal-content">
          <div className="modal-header">
            <h4 className="modal-title">
              <span className="icon icon-resend modal-icon modal-icon-blue" style={{ marginRight: '1rem' }} />
              <span style={{ textTransform: 'capitalize' }}>Resend {tableTab}</span>
            </h4>
          </div>
          <div className="modal-body">
            {modalColumns &&
              <>
                <DataTable
                  data={data}
                  columns={modalColumns}
                  responsive
                  striped
                  noHeader
                  sortIcon={(): React.Element<typeof React.Fragment> => {
                    return (
                      <>
                        <span className="-sort-desc" />
                        <span className="-sort-asc" />
                      </>
                    );
                  }}
                />

                 {tableTab === 'tickets' &&
                  <SimpleCheckbox
                    label='Void the ticket and generate a new one'
                    checked={needUpdateCode}
                    callBack={(): void => setNeedUpdateCode(!needUpdateCode)}
                    style={{ margin: '20px 0 0 0' }}
                  />
                 }
              </>
            }
            {modalPending && <div className='csspinner' style={spinnerStyles}/> }
          </div>
          <div className="modal-footer">
            <button className="btn btn-gray" onClick={handleCloseModal}>Close</button>
            <button
              className="btn btn-pink"
              onClick={(): void => tableTab === 'tickets' ? handleSendTickets(needUpdateCode) : handleSendReceipts()}
              style={{ opacity: modalPending ? '.7' : '1', pointerEvents: modalPending ? 'none' : 'auto' }}
            >
              Resend {tableTab}
            </button>
          </div>
        </div>
      </div>
    </Modal>
  );
};
